// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_99-0";